import { createStore } from "satcheljs";
import { ObservableMap } from "mobx";
import UserTeamSettingsStoreSchema from "./schema/UserTeamSettingsStoreSchema";

/**
 * UserTeamSettings store - user-specific configuration per team
 *
 * Manages user preferences for each team (e.g., mutedScheduleGroupIds for notification control).
 * ObservableMaps populated during bootstrap and updated via optimistic mutations.
 * MobX @observer components auto-rerender when store changes.
 *
 * Pattern matches TagStore, UserStore with ObservableMaps for dynamic data.
 */
const getStore = createStore<UserTeamSettingsStoreSchema>("userTeamSettingsStore", {
    userTeamSettingsByTeam: new ObservableMap<string, any>(),
    muteScheduleGroupStatusByTeamAndGroup: new ObservableMap<string, ObservableMap<string, boolean>>(),
    toggleLoadingByTeamAndGroup: new ObservableMap<string, ObservableMap<string, boolean>>(),
    loadErrorByTeam: new ObservableMap<string, boolean>()
});

export default getStore;
export { UserTeamSettingsStoreSchema };
